import { Box } from '@mui/material'
import groupEditIcon from 'assets/icons/group-edit-icon.png'
import { useState } from 'react'
import { COLORS } from 'styles/colors'
import TooltipHover from 'ui/TooltipHover'
import GroupSpecificEdit from '../group-specific-edit/GroupSpecificEdit'

export const EditGroupTooltip = ({ groupId }: { groupId: number }) => {
	const [drawerOpen, setDrawerOpen] = useState(false)

	return (
		<>
			<TooltipHover
				title='Редактировать группу'
				placement='bottom-end'
				disableHoverBackground
			>
				<Box
					component='span'
					onClick={() => setDrawerOpen(true)}
					sx={{
						width: '24px',
						height: '24px',
						display: 'inline-block',
						cursor: 'pointer',
						backgroundColor: COLORS.secondaryFont,
						maskImage: `url(${groupEditIcon})`,
						WebkitMaskImage: `url(${groupEditIcon})`,
						maskSize: 'contain',
						WebkitMaskSize: 'contain',
						maskRepeat: 'no-repeat',
						WebkitMaskRepeat: 'no-repeat',
						maskPosition: 'center',
						WebkitMaskPosition: 'center',
					}}
				/>
			</TooltipHover>
			<GroupSpecificEdit
				groupId={groupId}
				open={drawerOpen}
				onClose={() => setDrawerOpen(false)}
			/>
		</>
	)
}
